import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { KbAPI } from "../../../api/kb";

export default function KbListPage() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    async function load() {
      try {
        const data = await KbAPI.list(); // already correct endpoint  [oai_citation:2‡kb.js](sediment://file_00000000368c71f4944192512820d142)
        setArticles(data);
      } catch (err) {
        console.error(err);
        setError(err.message || "Failed to load KB");
      } finally {
        setLoading(false);
      }
    }

    load();
  }, []);

  if (loading) return <p className="p-4">Loading…</p>;
  if (error) return <p className="p-4 text-red-500">Error: {error}</p>;

  return (
    <div className="p-4 max-w-4xl">
      <h1 className="text-2xl font-semibold mb-4">Knowledge Base</h1>

      {articles.length === 0 && (
        <p className="text-gray-500">No articles available</p>
      )}

      <div className="space-y-3">
        {articles.map((a) => (
          <div
            key={a.id}
            className="border p-3 rounded cursor-pointer hover:bg-gray-50"
            onClick={() => navigate(`/helpdesk/kb/${a.id}`)}
          >
            <div className="font-medium">{a.title}</div>

            <div className="text-xs text-gray-500">
              {a.audience_type === "end_user"
                ? "End user"
                : "Technician"}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}